<template>
  <v-card>
    <v-dialog
      width="400"
      v-model="modal" lazy>
      <invitation-form @invited="expert => onInvited(expert)"></invitation-form>
    </v-dialog>

    <v-btn
      floating error light
      class="fixed"
      slot="activator"
      @click.native.stop="modal = true">
      <v-icon light>add</v-icon>
    </v-btn>

    <v-card-title>
      {{ $t('pages.team.title') }}
    </v-card-title>

    <v-data-table
      :headers="headers" :items="experts"
      :loading="loading"
      :no-data-text="$t('pages.team.noDataText')"
      :no-results-text="$t('pages.team.noResultsText')"
      :custom-sort="a => a"
      hide-actions>
      <template slot="headers" scope="props">
        {{ props.item.text }}
      </template>
      <template slot="items" scope="props">
        <td>
          <img :src="props.item.picture.thumb">
          <router-link :to="{ name: 'Expert', params: { id: props.item.id, tab: 'profile' } }">
            <span class="ml-5">{{ props.item.nickname }}</span>
          </router-link>
        </td>
        <td>
          <router-link :to="{ name: 'Expert', params: { id: props.item.id, tab: 'profile' } }">
            {{ props.item.email }}
          </router-link>
        </td>
        <td>
          <v-select
            :value="props.item.role"
            @input="role => updateRole({ id: props.item.id, role })"
            :items="roles"
            item-text="title"
            item-value="key">
          </v-select>
        </td>
        <td width="200">
          <v-btn
            @click.native.stop="updatePriority({ id: props.item.id, up: true })"
            icon class="primary--text">
            <v-icon>keyboard_arrow_up</v-icon>
          </v-btn>
          <v-btn
            @click.native.stop="updatePriority({ id: props.item.id, up: false })"
            icon class="primary--text">
            <v-icon>keyboard_arrow_down</v-icon>
          </v-btn>
          <v-btn
            router
            :href="{ name: 'Expert', params: { id: props.item.id, tab: 'profile' } }"
            icon class="primary--text">
            <v-icon>portrait</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import InvitationForm from '@/components/InvitationForm.vue'
  export default {
    components: {
      InvitationForm
    },
    data () {
      return {
        modal: false
      }
    },
    computed: {
      ...mapGetters({
        experts: 'skiliko/experts/experts',
        loading: 'skiliko/experts/isLoading'
      }),
      headers () {
        return ['nickname', 'email', 'role', 'actions']
          .map(h => ({
            text: this.$t(`pages.team.header.${h}`),
            sortable: false,
            left: true
          }))
      },
      roles () {
        return ['restricted', 'active', 'inactive']
          .map(r => ({ key: r, title: this.$t(`pages.team.roles.${r}`) }))
      }
    },
    methods: {
      ...mapActions({
        fetchAll: 'skiliko/experts/fetchAll',
        updateRole: 'skiliko/experts/updateRole',
        updatePriority: 'skiliko/experts/updatePriority'
      }),
      onInvited (expert) {
        this.modal = false
      }
    },
    mounted () {
      this.fetchAll()
    }
  }
</script>

<style lang="stylus" scoped>
  td { position: relative }

  img {
    position: absolute;
    top: 0;
    width: auto;
    height: 100%;
    float: left;
    left: 0;
  }

  button {
    display: inline-block;
  }

  .input-group {
    margin: 0;
  }
</style>

<style lang="stylus">
  td .input-group__details {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Team.vue